export const FETCH_RESTAURANT_CALLS = 'FETCH_RESTAURANT_CALLS';
export const FETCH_RESTAURANT_CALLS_SUCCESS = 'FETCH_RESTAURANT_CALLS_SUCCESS';
export const FETCH_RESTAURANT_CALLS_ERROR = 'FETCH_RESTAURANT_CALLS_ERROR';

export const RESET_RESTAURANT_CALLS = 'RESET_RESTAURANT_CALLS';

export const ADD_RESTAURANT_CALL = 'ADD_RESTAURANT_CALL';
export const REMOVE_RESTAURANT_CALL = 'REMOVE_RESTAURANT_CALL';
